import { ProtocolIcon } from "@/components/feedback/ProtocolIcon";
import { FIVE_DAY_INTRO, FIVE_DAY_TIMING, FIVE_DAY_SERVING, FIVE_DAY_REMINDERS } from "./fiveDayProtocol";

export const ProtocolIntroduction = ({ prefix }) => (
  <p className="mt-4 text-[14px] leading-relaxed text-white/75" data-testid={`${prefix}-protocol-copy`}>
    <strong className="font-semibold text-white" data-testid={`${prefix}-protocol-second-reach`}>For the second reach.</strong>{" "}{FIVE_DAY_INTRO}
  </p>
);

export const ProtocolDirections = ({ prefix }) => (
  <div className="mt-5 border-t border-white/15 pt-4" data-testid={`${prefix}-protocol-directions`}>
    <h3 className="label !text-[8px] !text-white/55" data-testid={`${prefix}-how-to-title`}>How to take it</h3>
    <div className="mt-4 grid gap-5" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 200px), 1fr))" }} data-testid={`${prefix}-protocol-timing`}>
      {FIVE_DAY_TIMING.map(({ id, label, title, copy }) => (
        <div key={id} className="min-w-0 border-l border-white/20 pl-3" data-testid={`${prefix}-protocol-${id}`}>
          <div className="sample-accent label !text-[8px]" data-testid={`${prefix}-protocol-${id}-label`}>{label}</div>
          <h4 className="mt-2 text-base font-semibold leading-snug text-white" data-testid={`${prefix}-protocol-${id}-title`}>{title}</h4>
          <p className="mt-1 text-[14px] leading-relaxed text-white/75" data-testid={`${prefix}-protocol-${id}-copy`}>{copy}</p>
        </div>
      ))}
    </div>
    <div className="mt-5 rounded-lg border border-[#31d17c]/30 bg-[#31d17c]/[0.06] px-4 py-3" data-testid={`${prefix}-protocol-serving`}>
      <div className="sample-accent label !text-[8px]" data-testid={`${prefix}-protocol-serving-label`}>Serve</div>
      <h4 className="mt-1 text-base font-semibold leading-snug text-white" data-testid={`${prefix}-protocol-serving-title`}>{FIVE_DAY_SERVING.title}</h4>
      <p className="mt-1 text-[13px] leading-relaxed text-white/75" data-testid={`${prefix}-protocol-serving-copy`}>{FIVE_DAY_SERVING.copy}</p>
    </div>
    <div className="mt-4 space-y-3" data-testid={`${prefix}-protocol-reminders`}>
      {FIVE_DAY_REMINDERS.map(({ icon, copy }) => (
        <p key={icon} className="grid grid-cols-[20px_minmax(0,1fr)] items-start gap-3 text-[13px] leading-relaxed text-white/80" data-testid={`${prefix}-protocol-reminder-${icon}`}>
          <ProtocolIcon kind={icon} className="sample-accent mt-0.5 h-5 w-5" />
          <span>{copy}</span>
        </p>
      ))}
    </div>
  </div>
);